import { LogIn, TriangleAlert } from 'lucide-react'
import { useT } from '@/components/visitone/visitone-provider'
import { EntryScreen, EntryTitle } from '@/components/visitone/entry-screen'
import { ProductMark } from '@/components/visitone/product-mark'
import { Button } from '@/components/ui/button'

/*
 * Callback error / retry surface only. Unauthenticated users without an Auth0
 * error are sent to hosted Universal Login by AuthGate. This screen never
 * collects credentials — one retry action, spoken error, no password field.
 */
export function LoginScreen({
  onLogin,
  busy = false,
  error,
}: {
  onLogin: () => void
  busy?: boolean
  error?: string | null
}) {
  const t = useT()

  return (
    <EntryScreen variant="landing">
      <div className="flex flex-col items-center gap-5 text-center">
        <ProductMark showName={false} className="scale-125" />
        <div className="flex flex-col gap-2">
          <EntryTitle className="text-balance">{t('core.auth.landingTitle')}</EntryTitle>
          <p className="text-pretty text-sm text-fg-muted">
            {t('core.auth.landingSummary')}
          </p>
        </div>
      </div>

      {error ? (
        <div
          role="alert"
          className="flex w-full items-start gap-2 rounded-sm border border-danger/60 bg-danger-surface px-3 py-2.5 text-sm text-danger"
        >
          <TriangleAlert aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
          <span>{error}</span>
        </div>
      ) : null}

      <Button
        variant="primary"
        size="lg"
        className="w-full"
        onClick={onLogin}
        disabled={busy}
      >
        <LogIn aria-hidden="true" />
        {error ? t('core.auth.retry') : t('core.auth.login')}
      </Button>
    </EntryScreen>
  )
}
